import type { JSX } from 'react';
import type { TextProps } from '../Text';
import { Text } from '../Text';

export type DataListItemLabelProps = TextProps;

/**
 * The label of the `DataListItem`. Extends the [Text]() component.
 */
export const DataListItemLabel = (props: DataListItemLabelProps): JSX.Element => {
  return (
    <Text
      variant="label4"
      {...props}
      renderAs="dt"
    />
  );
};

DataListItemLabel.displayName = 'DataListItemLabel';
